import * as React from "react"
import { cn } from "../../lib/utils"

/**
 * Modern Input component with shadcn/ui styling
 * Features:
 * - Brand color focus states (#FA6400)
 * - Consistent styling across the application
 * - Accessibility features (focus indicators)
 * - Clean, modern design matching current UI
 */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }